"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeatedDiscussions = void 0;
var GlobalEventName_1 = require("../GlobalEventName");
var PartyName_1 = require("../../parties/PartyName");
var Resources_1 = require("../../../Resources");
var Tags_1 = require("../../../cards/Tags");
var HeatedDiscussions = (function () {
    function HeatedDiscussions() {
        this.name = GlobalEventName_1.GlobalEventName.HEATED_DISCUSSIONS;
        this.description = 'Lose 1 M€ for each science tag. Gain 1 heat per heat production (max 5) and 2 heat per influence.';
        this.revealedDelegate = PartyName_1.PartyName.SCIENTISTS;
        this.currentDelegate = PartyName_1.PartyName.KELVINISTS;
    }
    HeatedDiscussions.prototype.resolve = function (game, turmoil) {
        var _this = this;
        game.getPlayers().forEach(function (player) {
            player.addResource(Resources_1.Resources.MEGACREDITS, -player.getTagCount(Tags_1.Tags.SCIENCE, false, false), { log: true, from: _this.name });
            player.addResource(Resources_1.Resources.HEAT, Math.min(5, player.getProduction(Resources_1.Resources.HEAT)) + 2 * turmoil.getPlayerInfluence(player), { log: true, from: _this.name });
        });
    };
    return HeatedDiscussions;
}());
exports.HeatedDiscussions = HeatedDiscussions;
//# sourceMappingURL=HeatedDiscussions.js.map